import { tariffBuyCustomFeatures } from 'reactApp/appHelpers/featuresHelpers';
import { newNeuroThreeTariffsPopup } from 'reactApp/appHelpers/featuresHelpers/features/aiTariff';
import {
    AI_TARIFF_TOOLBAR_TOOLTIP_BUY_TITLE,
    AI_TARIFF_TOOLBAR_TOOLTIP_CAMPAIGN_IDS,
    AI_TARIFF_TOOLBAR_TOOLTIP_FEATURES_ID,
    AI_TARIFF_TOOLBAR_TOOLTIP_PRODUCT_ID,
} from 'reactApp/appHelpers/featuresHelpers/features/aiTariffToolbarTooltip';
import { openThreeTariffsPopup } from 'reactApp/modules/payment/payment.helpers';
import { openBuyCheckout } from 'reactApp/modules/payment/payment.module';
import { store } from 'reactApp/store';

const paySource = 'ai-tariff-toolbar';

export const addAITariffToolbarListeners = () => {
    const headline = document.querySelector('#ph-whiteline');

    headline?.addEventListener('promoBalloonCompleteClick', (evt) => {
        const detail = evt.detail;

        if (detail.project === 'mailspace' && AI_TARIFF_TOOLBAR_TOOLTIP_CAMPAIGN_IDS.includes(String(detail.campaignId))) {
            evt.preventDefault();

            if (newNeuroThreeTariffsPopup) {
                openThreeTariffsPopup({ dispatch: store.dispatch, paySource });
                return;
            }

            store.dispatch(
                openBuyCheckout({
                    title: AI_TARIFF_TOOLBAR_TOOLTIP_BUY_TITLE,
                    productId: AI_TARIFF_TOOLBAR_TOOLTIP_PRODUCT_ID,
                    featuresList: tariffBuyCustomFeatures[AI_TARIFF_TOOLBAR_TOOLTIP_FEATURES_ID],
                    hideOtherTariffs: true,
                    paySource,
                })
            );
        }
    });
};
